import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { USER_ROLES } from "../../../API/UserApi";
import apiHeader from "../../../Components/ApiHeader";

export const getUserRolesAPI: any = createAsyncThunk(
  "getUserRoles",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(USER_ROLES, {
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
        params: params,
      });
      return { users: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
